export default __webpack_public_path__ + "static/media/tiktok_features.2cb5e5cf.png";